import axios from "axios";
import { BACKEND_URL } from "../backendURL";


class VotersService {

    getSimpleList(token, filters) {
        const searchFilters = filters.searchFilters;
        const params = { ...searchFilters };

        const config = {
            headers: {
                'Authorization': "Token " + token
            },
            params: params
        };

        const api_url = BACKEND_URL + "/api/patronage/anetar-search-voters-name-surname/";
        return axios.get(api_url, config);
    };

}

export default new VotersService();